module.exports = __webpack_public_path__ + "img/Causes-Impact identification.b6610ceb.svg";